import Service from "../../../Services/index";
import moment from "moment";

const TaxPayment = {
    namespaced: true,
    state: {
        tax_payment_list: [],
        form: {
            id: "",
            vendor: null,
            date: "",
            tax_number: "",
            po_id: "",
            po: [],
            tax_from_vendor: "",
            date_from_vendor: "",
            billing_number: "",
            total: "",
            is_vat: "",
            from_cs: false,
            total_before_vat: '',
            tax_payment_details: [{
                id: "",
                name: "",
                quantity: "",
                price: "",
                total: "",
                material_id: "",
                material: "",
                account_id: '',
                account: '',
                before_vat: ''
            }],
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        page: 1
    },
    mutations: {
        GET_TAX_PAYMENT_LIST: (state, res) => {
            state.tax_payment_list = res.data;
            state.tax_payment_list.forEach(i => {
                if (i.is_vat && i.tax_payment_details.length > 0 && i.from_cs) {
                    let total = 0;
                    i.tax_payment_details.forEach(j => {
                        total += j.price;
                    })
                    i.total_before_vat = total;
                }
            })
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_TAX_PAYMENT_BY_ID: (state, res) => {
            state.form = {
                id: res.id,
                date: res.date,
                vendor_id: res.vendor_id,
                tax_number: res.tax_number,
                tax_from_vendor: res.tax_from_vendor,
                date_from_vendor: res.date_from_vendor,
                billing_number: res.billing_number,
                total: res.total,
                po: res.po,
                vendor: res.vendor,
                is_vat: res.is_vat,
                tax_payment_details: res.tax_payment_details,
                from_cs: res.from_cs
            };
            if (res.tax_payment_details.length < 1) {
                state.form.tax_payment_details = [{
                    id: "",
                    name: "",
                    quantity: "",
                    price: "",
                    total: "",
                    material_id: "",
                    material: "",
                    account_id: '',
                    account: '',
                    before_vat: '',
                }]
            } else if (res.is_vat && res.tax_payment_details.length > 0 && res.from_cs) {
                //หากมีภาษี ให้หักออกจากยอดเต็ม
                state.form.tax_payment_details.forEach(i => {
                    // i.before_vat = i.price;
                    i.price = (i.price * 100 / 107).toFixed(2)
                })
            }
        },
        CLEAR_TAX_PAYMENT: (state) => {
            let currentDate = moment().format("YYYY-MM-DD");
            state.form = {
                id: "",
                vendor: null,
                date: currentDate,
                tax_number: "",
                po_id: "",
                po: [],
                tax_from_vendor: "",
                date_from_vendor: currentDate,
                billing_number: "",
                total: "",
                is_vat: "",
                tax_payment_details: [{
                    id: "",
                    name: "",
                    quantity: "",
                    price: "",
                    total: "",
                    material_id: "",
                    material: "",
                    account_id: '',
                    account: '',
                }],
            }
        },
        ADD_TAX_PAYMENT_DETAILS: state => {
            state.form.tax_payment_details = [
                ...state.form.tax_payment_details,
                {
                    id: "",
                    name: "",
                    quantity: "",
                    price: "",
                    total: "",
                    material_id: "",
                    material: "",
                    account_id: '',
                    account: '',
                }
            ]
        },
        REMOVE_TAX_PAYMENT_DETAILS: (state, index) => {
            state.form.tax_payment_details = state.form.tax_payment_details.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        UPDATE_PAGE: (state, page) => {
            state.page = page
        }
    }
    ,
    actions: {
        getTaxPaymentList({commit}, {page = 1}) {
            return Service.TaxPayment.getTaxPayment(page).then(res => {
                commit("GET_TAX_PAYMENT_LIST", res);
            })
        },
        createTaxPayment({commit}, data) {
            return Service.TaxPayment.createTaxPayment(data).then(() => {
                //console.log("create success");
            });
        },
        updateTaxPayment({commit}, {id, data}) {
            return Service.TaxPayment.updateTaxPayment(id, data).then(() => {
                //console.log("update success");
            });
        },
        showTaxPayment({commit}, id) {
            return Service.TaxPayment.showTaxPayment(id).then(res => {
                commit("GET_TAX_PAYMENT_BY_ID", res)
            });
        },
        addTaxPaymentDetails({commit}) {
            commit("ADD_TAX_PAYMENT_DETAILS");
        },
        removeTaxPaymentDetails({commit}, index) {
            commit("REMOVE_TAX_PAYMENT_DETAILS", index);
        },
        searchTaxPayment({commit}, {page = 1, data}) {
            return Service.TaxPayment.searchTaxPayment(page, data).then(res => {
                commit("GET_TAX_PAYMENT_LIST", res);
            })
        },
        selectTaxPayment({commit}, data) {
            return Service.TaxPayment.selectTaxPayment(data);
        },
        clearTaxPayment({commit}) {
            commit("CLEAR_TAX_PAYMENT");
        },
        //tax_payment_account
        getTaxPaymentAccount({commit}, {page, code}) {
            return Service.TaxPayment.getTaxPaymentAccount(page, code);
        },
        showTaxPaymentAccount({commit}, id) {
            return Service.TaxPayment.showTaxPaymentAccount(id)
        },
        saveTaxPaymentAccount({commit}, {id, data}) {
            if (id) {
                return Service.TaxPayment.editTaxPaymentAccount(id, data);
            } else {
                return Service.TaxPayment.createTaxPaymentAccount(data);
            }
        },
        deleteTaxPaymentAccount({commit}, id) {
            return Service.TaxPayment.deleteTaxPaymentAccount(id);
        },
        generateTaxPaymentCode({commit}) {
            return Service.TaxPayment.generateTaxPaymentCode();
        },
        getAllTaxPaymentAccount({commit}) {
            return Service.TaxPayment.getAllTaxPaymentAccount();
        },
        closeTaxPayment({commit}, date) {
            return Service.TaxPayment.closeTaxPayment(date);
        },
        updatePage({commit}, page) {
            //console.log(page)
            commit('UPDATE_PAGE', page)
        }
    }
};

export default TaxPayment;
